import { useState, useEffect } from 'react';
import { Row, Spin } from 'antd';
import classNames from 'classnames/bind';
import styles from './MiddleSharePage.module.scss';
import { IMAGES } from '~/assets/assetsPath';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import shareAPI from '~/api/Share';
import { useSelector } from 'react-redux';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import config from '~/config';

const cx = classNames.bind(styles);

const MiddleSharePage = () => {
    const userInfo = useSelector((state) => state?.user?.userInfo);
    //Get 100vh follow browser
    const documentHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
    };
    window.addEventListener('resize', documentHeight);
    documentHeight();

    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);

    const handleClickNavigate = async () => {
        const search = location?.search?.split('?').join('');
        const productId = new URLSearchParams(search)?.get('product');
        const offerId = new URLSearchParams(search)?.get('offer');
        const sharerId = new URLSearchParams(search)?.get('sharer_id');

        if (productId && sharerId) {
            navigate(`/thong-tin-san-pham/${productId}?sharer_id=${sharerId}`);
            if (sharerId !== userInfo.id) {
                const body = {
                    product_id: productId,
                    sharer_id: sharerId,
                };
                await shareAPI.clickOnLinkAPI(body);
            }
        }
        if (offerId && sharerId) {
            navigate(`/thong-tin-nap-tien/${offerId}?sharer_id=${sharerId}`);
            if (sharerId !== userInfo.id) {
                const body = {
                    offer_id: offerId,
                    sharer_id: sharerId,
                };
                await shareAPI.clickOnLinkAPI(body);
            }
        }
    };
    const [linkDown, setLinkDown] = useState('');

    useEffect(() => {
        if (location?.search) {
            const search = location?.search?.split('?').join('');
            const productId = new URLSearchParams(search)?.get('product');
            const offerId = new URLSearchParams(search)?.get('offer');
            const sharerId = new URLSearchParams(search)?.get('sharer_id');
            let temp = '';
            if (productId) {
                temp = `product=${productId}`;
            }
            if (offerId) {
                temp = `offer=${offerId}`;
            }
            const linkTemp = `https://vbeauty.page.link/?&link=https://abeauty-web.web.app?${temp}%26sharer_id=${sharerId}&efr=1&ibi=com.hitek.abeauty&isi=1625638866&apn=com.hitek.abeauty`;

            setLinkDown(linkTemp);
        }
        // eslint-disable-next-line
    }, [location?.search]);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangDieuHuongChiaSe');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <Spin spinning={isLoading}>
                <div className={cx('container')}>
                    <div className={cx('form_container')}>
                        <Row justify="center">
                            {/* <div className={cx('logo_section')}>
                                <img
                                    src={IMAGES.ImageLogoGold}
                                    alt=""
                                    width="200px"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => navigate(config.routes.home)}
                                />
                            </div> */}
                            <img
                                src={IMAGES.NewLogo}
                                alt=""
                                width="200px"
                                style={{
                                    cursor: 'pointer',
                                    height: '100%',
                                    objectFit: 'contain',
                                    objectPosition: 'center',
                                }}
                                onClick={() => navigate(config.routes.home)}
                            />
                        </Row>
                        <Row justify="center" className={cx('content')}>
                            Welcome to Beauty-ms.
                        </Row>
                        <Row justify="center" className={cx('content')}>
                            An e-commerce platform with the first collaborator model in Vietnam.
                        </Row>
                        <Row justify="center">
                            <div className={cx('btn')} onClick={handleClickNavigate}>
                                Go to Website
                            </div>
                        </Row>
                        <Row justify="center">
                            {/* <a href="https://vbeauty.app.link/download" target="_blank" rel="noreferrer">
                                <div className={cx('btn')}>Get app</div>
                            </a> */}
                            <a href={linkDown} target="_blank" rel="noreferrer">
                                <div className={cx('btn')}>Open application</div>
                            </a>
                        </Row>
                    </div>
                </div>
            </Spin>
        </div>
    );
};

export default MiddleSharePage;
